import React, { useState } from 'react';
import { Grid } from 'semantic-ui-react';
import classNames from 'classnames';
import { CircleImage, HeadingWithParagraph, LinkWithArrow } from '.';
import { useBreakpoints, Directions, Breakpoints } from 'src/utils/breakpoint-utils';
import * as Styles from 'src/styles/contributing-experts.module.scss';

interface IContributingExperts {
    name: string;
    title: string;
    cta: string;
    ctaLabel: string;
    bio: {
        bio: string;
    };
    image: {
        fixed: {
            src: string;
        };
    };
    imagePosition?: 'start' | 'end';
}

const ContributingExperts = ({
    name,
    title,
    cta,
    ctaLabel,
    bio,
    image,
    imagePosition,
}: IContributingExperts) => {
    const isMobile = useBreakpoints(Breakpoints.lg, Directions.down);

    const rowClasses = classNames({
        [`${Styles.imageEnd}`]: imagePosition === 'end',
    });

    const imageContainerClasses = classNames(
        imagePosition === 'end'
            ? 'padding-right--0 padding-left--large'
            : 'padding-left--0 padding-right--large'
    );

    return (
        <Grid className="padding-bottom--large margin--0">
            {isMobile ? (
                <>
                    <Grid.Row
                        className={`${rowClasses} padding-vertical--0`}
                        verticalAlign="middle"
                    >
                        <Grid.Column className="padding-horizontal--0" computer={5}>
                            <CircleImage
                                src={image.fixed.src}
                                className={Styles.mobileTabletCircleImage}
                            />
                        </Grid.Column>
                        <Grid.Column className="padding-horizontal--0" computer={11}>
                            <HeadingWithParagraph
                                headingLabel={`${name},`}
                                headingSize="h5"
                                headingWeight="bold"
                                headingClass={`bgcolor-pv-pnf-bg ${Styles.heading}`}
                                alignment="vertical"
                                secondaryHeadingClass={Styles.secondaryHeading}
                                secondaryHeadingLabel={title}
                            />
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row className={'padding-vertical--0'}>
                        <HeadingWithParagraph
                            pClass="experts-paragraph"
                            pLabel={bio.bio}
                            alignment="vertical"
                        />
                        {cta && <LinkWithArrow to={cta} label={ctaLabel} />}
                    </Grid.Row>
                </>
            ) : (
                <Grid.Row
                    className={`padding-vertical--small ${rowClasses}`}
                    verticalAlign="middle"
                >
                    <Grid.Column className={imageContainerClasses} computer={5}>
                        <CircleImage src={image.fixed.src} className={Styles.circleImage} />
                    </Grid.Column>
                    <Grid.Column className="padding-horizontal--0" computer={11}>
                        <HeadingWithParagraph
                            headingLabel={`${name},`}
                            headingSize="h5"
                            headingWeight="bold"
                            headingClass={`bgcolor-pv-pnf-bg margin-bottom--small ${Styles.heading}`}
                            pClass="experts-paragraph"
                            pLabel={bio.bio}
                            alignment="vertical"
                            secondaryHeadingClass={Styles.secondaryHeading}
                            secondaryHeadingLabel={title}
                        />
                        {cta && <LinkWithArrow to={cta} label={ctaLabel} />}
                    </Grid.Column>
                </Grid.Row>
            )}
        </Grid>
    );
};

export default ContributingExperts;
